<template>
  <div id="app">
    <div class="layout">
      <ms-user-nav v-show="$route.path.indexOf('/userCenter') == 0"></ms-user-nav>
      <ms-navbar v-show="$route.path.indexOf('/userCenter') != 0 && !whiteList.includes($route.path)"/>
      <router-view :key="$route.fullpath"/>

      <!-- 全局右侧悬浮微信二维码 -->
      <transition name="fade">
        <div class="right-qr-code" id="rightQrCode" v-show="showQrCode">
          <div class="qr-img">
            <img src="@/assets/images/qrcode.png" alt="微信二维码" />
          </div>
          <div class="qr-desc">
            添加官方客服<br />了解更多内容
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { checkTenantAndModule } from '@/api/index'
import { removeToken } from '@/utils/auth'
export default {
  name: "App",
  data() {
    return {
      beforeUnloadTime: 0,
      gapTime: 0,
      whiteList: ['/register', '/login', '/forgetPassword', '/registerInfo', '/forgetPassword', '/enterprise/register', '/signLogin', '/sign'],
      scrollTop: 0
    }
  },
  computed: {
    showQrCode() {
      // 1. 如果在授权相关的白名单页面，不显示
      if (this.whiteList.includes(this.$route.path)) {
        return false;
      }
      // 2. 如果在首页或选货系统页面，滚动高度必须大于 420 像素才显示（避开首屏大 Banner）
      var isHome = this.$route.path === '/home' || this.$route.path === '/';
      var isSelectionSys = this.$route.path.indexOf('/selectionSys') === 0;
      if (isHome || isSelectionSys) {
        return this.scrollTop > 420;
      }
      // 3. 其它页面默认常驻固定悬浮显示
      return true;
    }
  },
  mounted() {
    // this.checkWeb();
    // window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))
    // window.addEventListener('unload', e => this.unloadHandler(e))
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll(); // 初始化
  },
  methods: {
    handleScroll() {
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    },
    beforeunloadHandler(e){
      this.beforeUnloadTime = new Date().getTime();
    },
    unloadHandler(e){
      this.gapTime = new Date().getTime() - this.beforeUnloadTime;
      //判断是窗口关闭还是刷新
      if(this.gapTime <= 5){//关闭做事
        removeToken();
        this.$store.dispatch('user/logout')
      } else {//刷新做事
      
      }
    },
    checkWeb() {
      checkTenantAndModule().then((res) => {}).catch((err) => {
        this.$router.push("/404");
      });
    },
  },
  destroyed() {
    // window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e))
    // window.removeEventListener('unload', e => this.unloadHandler(e))
    window.removeEventListener('scroll', this.handleScroll);
  }
};
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  line-height: 1.42857143;
  color: #333;
  .layout {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 100vh;
  }
}

/* 全局右侧悬浮微信二维码 */
.right-qr-code {
  position: fixed;
  left: 50%;
  margin-left: 785px; /* 1500px / 2 = 750px, +35px gap */
  top: 420px;
  width: 130px;
  padding: 15px 10px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  text-align: center;
  z-index: 99999;
  box-sizing: border-box;

  .qr-img img {
    width: 100px;
    height: 100px;
    display: block;
    margin: 0 auto;
  }

  .qr-desc {
    font-size: 11px;
    color: #6b7280;
    margin-top: 8px;
    line-height: 1.4;
  }
}

/* Vue 渐变过渡动画 */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

/* 响应式适配 */
@media (max-width: 1780px) {
  .right-qr-code {
    position: fixed;
    left: auto;
    right: 5px;
    margin-left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
}

@media (max-width: 1200px) {
  /* 当屏幕宽度小于等于 1200px 时，隐藏二维码悬浮窗 */
  .right-qr-code {
    display: none !important;
  }
}
</style>
